import {
  type SemanticLegendSettingsWithCategoricalConfig,
  YAxisValues,
} from '../../types';
import {
  SEMANTIC_LEGEND_PALETTE_CATEGORICAL_CONFIG_DEFAULT,
  type SemanticLegendPalette,
} from './colorPalettes';
import {getColorFromValue} from './getDefaultBucketColors';
import {type ConfigValueForRun} from './useConfigValuesAggregation';

export function getRunColorMap(
  constructedSemanticLegendData: SemanticLegendSettingsWithCategoricalConfig,
  configValuesForRunCategories: ConfigValueForRun[],
  semanticLegendPalette: SemanticLegendPalette | undefined
) {
  const categoryRunColorMap =
    constructedSemanticLegendData?.yAxisValue === YAxisValues.Config_Categories
      ? configValuesForRunCategories.reduce(
          (acc, curr) => {
            const category = curr.value;
            const bucketIndex =
              constructedSemanticLegendData.selectedCategories?.findIndex(
                selectedCategory => selectedCategory === category
              ) ?? -1;
            let colorString = constructedSemanticLegendData.excludedRunColor;
            if (bucketIndex !== -1) {
              const customColor =
                constructedSemanticLegendData.bucketCustomizations?.[
                  bucketIndex
                ]?.color;
              if (customColor) {
                colorString = customColor;
              } else {
                colorString = getColorFromValue(
                  bucketIndex,
                  constructedSemanticLegendData.selectedCategories?.length ?? 0,
                  semanticLegendPalette ??
                    SEMANTIC_LEGEND_PALETTE_CATEGORICAL_CONFIG_DEFAULT
                );
              }
            }
            acc[curr.runName] = colorString;
            return acc;
          },
          {} as Partial<Record<string, string>>
        )
      : {};
  return categoryRunColorMap;
}
